<template>
  <div>orders analysis</div>
</template>

<script>
export default {
  name: "c_orders_analysis"
}
</script>

<style scoped>

</style>
